<template>
    <div class="all-wrapper solid-bg-all">
        <div v-if="valid" class="layout-w">
            <div class="logo-w" style="width:100%;padding-top:20px;">
                <a href="/">
                    <img alt="" src="/images/logo.png">
                </a>
            </div>
            <div class="content-w" style="margin-top:10px;">
                <div class="iframe">
                    <button class="btn btn-info download" @click="download">Download as PDF</button>
                    <iframe :src="url+'/html'"></iframe>
                </div>
            </div>
        </div>
        <div v-else class="content-i">
            <div class="content-box">
                <div class="big-error-w">
                    <h1>404</h1>
                    <h5>Page not Found</h5>
                    <h4>Oops, Something went missing...</h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            valid: false,
            url: this.peer.common.apiBaseDomain()+'/Common/download/legal/peer_'+this.$route.params.pathMatch
        }
    },
    
    mounted() {
        this.toggleBodyClass('addClass', 'with-content-panel')
        this.toggleBodyClass('addClass', 'full-screen')
        
        if(this.peer.$.inArray(this.$route.params.pathMatch, [
            'cookie_policy',
            'end_user_license_agreement',
            'privacy_policy',
            'terms_and_conditions'
        ]) !== -1) {
            this.valid = true
        }
    },
    
    destroyed() {
        this.toggleBodyClass('removeClass', 'with-content-panel')
        this.toggleBodyClass('removeClass', 'full-screen')
    },
    
    methods: {
        applyStyle(styleDef) {
            let style = document.createElement('style')
            style.type = 'text/css'
            document.head.appendChild(style)
            style.innerHTML = styleDef
        },
        
        toggleBodyClass(addRemoveClass, className) {
            const el = document.body
            
            if(addRemoveClass === 'addClass')
                el.classList.add(className)
            else
                el.classList.remove(className)
        },
        
        download() {
            this.peer.misc.download(this.url+'/pdf/save')
        }
    }
}
</script>

<style scoped>
.layout-w {
    width: 90%;
    margin: auto;
}
.btn.download {
    margin-top: -35px;
    float: right;
    margin-right: 0px;
}
.iframe iframe {
    width: 100%;
    height: 600px;
    border: 1px solid #dbd7d7;
}
</style>
